export function getGoogleDriveMediaUrl(mediaUrl, driveFileId, webViewLink, thumbnailUrl, highQuality = true) {
  // 1. Primeiro verificar se temos driveFileId (mais confiável)
  if (driveFileId && typeof driveFileId === 'string' && driveFileId.trim()) {
    return `https://lh3.googleusercontent.com/d/${driveFileId}`;
  }

  // 2. Verificar se mediaUrl já é uma URL uc?id= válida e convertê-la
  if (mediaUrl && typeof mediaUrl === 'string' && mediaUrl.startsWith('https://drive.google.com/uc?id=')) {
    const fileId = mediaUrl.match(/id=([a-zA-Z0-9_-]+)/)?.[1];
    if (fileId) {
      return `https://lh3.googleusercontent.com/d/${fileId}`;
    }
    return mediaUrl;
  }
  
  // 3. Se mediaUrl é um ID do Google Drive (string longa), converter
  if (mediaUrl && typeof mediaUrl === 'string' && /^[a-zA-Z0-9_-]{20,}$/.test(mediaUrl)) {
    return `https://lh3.googleusercontent.com/d/${mediaUrl}`;
  }
  
  // 4. Se mediaUrl é uma URL de thumbnail, extrair ID e converter
  if (mediaUrl && typeof mediaUrl === 'string' && mediaUrl.includes('thumbnail?id=')) {
    const fileId = mediaUrl.match(/id=([a-zA-Z0-9_-]+)/)?.[1];
    if (fileId) {
      return `https://lh3.googleusercontent.com/d/${fileId}`;
    }
  }
  
  // 5. Se mediaUrl é uma URL válida (não thumbnail), usar ela
  if (mediaUrl && typeof mediaUrl === 'string' && mediaUrl.startsWith('https://') && !mediaUrl.includes('thumbnail')) {
    return mediaUrl.replace('export=view&', '').replace('?export=view&', '?');
  }
  
  // 6. Tentar thumbnailUrl se disponível
  if (thumbnailUrl && typeof thumbnailUrl === 'string' && thumbnailUrl.startsWith('https://')) {
    if (highQuality && thumbnailUrl.includes('thumbnail?id=')) {
      const fileId = thumbnailUrl.match(/id=([a-zA-Z0-9_-]+)/)?.[1];
      if (fileId) {
        return `https://lh3.googleusercontent.com/d/${fileId}`;
      }
    }
    return thumbnailUrl;
  }
  
  // 7. Último recurso: retornar mediaUrl se existir
  if (mediaUrl && typeof mediaUrl === 'string' && mediaUrl.trim()) {
    return mediaUrl;
  }
  
  return null;
}
